import { Avatar as AntAvatar, AvatarProps } from "antd";

export default function Avatar(props: AvatarProps) {
  return <AntAvatar {...props} data-test-id="avatar" />;
}
